import { useEffect, useState } from "react";
export function usePriorityResolver({ overrideActive, scheduledUrl, defaultUrl }) {
  const [mode, setMode] = useState({
    type: "DEFAULT",
    url: defaultUrl || null,
  });
  useEffect(() => {
    if (overrideActive) {
      console.log("[PriorityResolver] Mode: OVERRIDE");
      setMode({ type: "OVERRIDE", url: overrideActive.url });
    } else if (scheduledUrl) {
      console.log("[PriorityResolver] Mode: SCHEDULED");
      setMode({ type: "SCHEDULED", url: scheduledUrl });
    } else {
      console.log("[PriorityResolver] Mode: DEFAULT");
      setMode({ type: "DEFAULT", url: defaultUrl });
    }
  }, [overrideActive, scheduledUrl, defaultUrl]);
  return mode;
}
